<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100 q-body">

            <div class="top-body">
                <div class="top-left">
                    <img class="head-img" :src="questionInfo.put_user_head" alt="">
                    <div class="top-name">
                        <p><span class="user-name">{{questionInfo.put_user_name}}</span><span class="user-name-spk">Ask to You:</span></p>
                        <p class="time-text">{{questionInfo.create_time}}</p>
                    </div>
                    <img class="head-img" :src="questionInfo.answer_user_head" alt="">
                </div>
                <div class="top-right">
                    <div class="send-btn" :class="content.length>0 ? 'send-btn-a' : ''" @click="onPost()">发送</div>
                </div>
            </div>

            <div class="content-info">{{questionInfo.question_info}}</div>

            <textarea v-model="content" placeholder="写下您的答案…"></textarea>

        </div>
    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片
    export default {
        components: {
            Topheader
        },
        name: "answerQ",
        data() {
            return {
                id:'',
                content: '',
                info:{},
                questionInfo:{}
            };
        },
        created() {
            this.id=this.$route.query.id;
            this.getInfo();
        },
        //方法定义
        methods: {
            getInfo(){
              let _this=this;
              _this.common.request('api/dynamic/questionInfo',{id:_this.id},function (res) {
                  if(res.status == 200){
                      console.log(res);
                      _this.info=res.data.info;
                      _this.questionInfo=res.data.questionInfo;
                  }
              });

              //阅读给我的提问
              _this.common.request('api/question/readToMeQuestion',{dynamic_id:_this.id},function (res) {

              },'post')
            },
            onPost(){
                if(this.content.length <= 0){
                    this.common.vMessage('请填写您要回答的内容','warning');
                    return;
                }
                let _this=this;
                let data={
                    dynamic_id:_this.id,
                    result_info:_this.content,
                };
                _this.common.request('api/question/answer',data,function (res) {
                    if(res.status == 200){
                        _this.$message({
                            message: res.message,
                            type: "success",
                            duration: 1500,
                            center: true,
                            onClose: function(res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post');
            }
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">

.q-body{
    height:703px;
    background:rgba(255,255,255,1);
    margin-top: 20px;
    padding: 20px;
}
    .top-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .top-left{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .head-img{
        width:64px;
        height:64px;
        border-radius:50%;
    }
    .send-btn{
        width:94px;
        height:44px;
        background:rgba(232,232,232,1);
        border-radius:22px;
        text-align: center;
        line-height: 44px;
        color: #15A3F5;
        cursor: pointer;
    }
    .send-btn-a{
        background-color: #388DE5;
        color: #FFFFFF;
    }
    .top-name{
        margin: 0 20px;
        line-height: 10px;
    }
    .user-name{
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
    }
    .user-name-spk{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(87,87,87,1);
        margin-left: 10px;
    }
    .time-text{
        font-size:14px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(87,87,87,1);
        line-height: 10px;
    }
    .content-info{
        width: 1000px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
        line-height:28px;
        margin-top: 20px;
    }
    textarea{
        color: #333;
        font-size: 14px;
        outline: none;
        border: none;
        width: 100%;
        resize: none;
        height: 520px;
        margin-top: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/view/answerQ.vue